var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastVacancyResolution = function SvgFastVacancyResolution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fast-vacancy-resolution_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.617,
    height: 33.858,
    x: 7.462,
    y: 13.174,
    fill: "#fff",
    rx: 16.929
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.617,
    height: 33.858,
    x: 7.462,
    y: 13.174,
    fill: "#000",
    rx: 16.929
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.617,
    height: 33.858,
    x: 7.462,
    y: 13.174,
    fill: "url(#fast-vacancy-resolution_svg__b)",
    fillOpacity: 0.8,
    rx: 16.929
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.199,
    height: 33.199,
    x: 7.352,
    y: 13.504,
    fill: "#fff",
    rx: 16.599
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.199,
    height: 33.199,
    x: 7.352,
    y: 13.504,
    fill: "url(#fast-vacancy-resolution_svg__c)",
    fillOpacity: 0.2,
    rx: 16.599
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.199,
    height: 33.199,
    x: 7.352,
    y: 13.504,
    stroke: "#000",
    strokeWidth: 0.66,
    rx: 16.599
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.078,
    height: 0.879,
    x: 9.221,
    y: 30.323,
    fill: "#000",
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.078,
    height: 0.879,
    x: 24.172,
    y: 15.372,
    fill: "#000",
    rx: 0.44,
    transform: "rotate(90 24.172 15.372)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.998,
    height: 0.814,
    x: 11.871,
    y: 23.186,
    fill: "#000",
    rx: 0.407,
    transform: "rotate(29.104 11.871 23.186)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.998,
    height: 0.814,
    x: 16.659,
    y: 17.64,
    fill: "#000",
    rx: 0.407,
    transform: "rotate(57.166 16.659 17.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.078,
    height: 0.879,
    fill: "#000",
    rx: 0.44,
    transform: "matrix(-1 0 0 1 38.95 30.323)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.998,
    height: 0.814,
    fill: "#000",
    rx: 0.407,
    transform: "scale(-1 1)rotate(29.104 -62.81 -58.327)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.998,
    height: 0.814,
    fill: "#000",
    rx: 0.407,
    transform: "scale(-1 1)rotate(57.166 -31.945 -20.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.377 28.296a.88.88 0 0 1 .312-.672l7.695-6.496a.88.88 0 0 1 1.135 0l7.695 6.496a.88.88 0 0 1 .312.672v10.381a.88.88 0 0 1-.88.88h-15.39a.88.88 0 0 1-.879-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    d: "M15.377 28.296a.88.88 0 0 1 .312-.672l7.695-6.496a.88.88 0 0 1 1.135 0l7.695 6.496a.88.88 0 0 1 .312.672v10.381a.88.88 0 0 1-.88.88h-15.39a.88.88 0 0 1-.879-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fast-vacancy-resolution_svg__d)",
    fillOpacity: 0.6,
    d: "M15.377 28.296a.88.88 0 0 1 .312-.672l7.695-6.496a.88.88 0 0 1 1.135 0l7.695 6.496a.88.88 0 0 1 .312.672v10.381a.88.88 0 0 1-.88.88h-15.39a.88.88 0 0 1-.879-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.446,
    d: "m19.936 31.681 2.475 2.893 4.756-5.062"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.319,
    d: "M46.157 24.167H57.15M46.157 29.443h7.476M46.157 34.72h4.398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.179 8.395c1.786 0 3.297 1.105 3.804 2.628.089.266-.132.517-.413.51q-.365-.012-.733-.011h-1.994a28 28 0 0 0-4.093.303c-.28.042-.533-.186-.47-.463.383-1.695 1.983-2.967 3.899-2.967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fast-vacancy-resolution_svg__e)",
    fillOpacity: 0.31,
    d: "M24.179 8.395c1.786 0 3.297 1.105 3.804 2.628.089.266-.132.517-.413.51q-.365-.012-.733-.011h-1.994a28 28 0 0 0-4.093.303c-.28.042-.533-.186-.47-.463.383-1.695 1.983-2.967 3.899-2.967"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fast-vacancy-resolution_svg__b",
    x1: 49.265,
    x2: 5.442,
    y1: 29.66,
    y2: 3.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fast-vacancy-resolution_svg__c",
    x1: 20.214,
    x2: 24.172,
    y1: 37.578,
    y2: 61.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fast-vacancy-resolution_svg__d",
    x1: 23.952,
    x2: 23.952,
    y1: 20.649,
    y2: 39.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fast-vacancy-resolution_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 2.22026 -4.99558 0 24.176 9.194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fast-vacancy-resolution_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })))));
};
export default SvgFastVacancyResolution;